// Mutations
export const SET_ADDRESS = "SET_ADDRESS";
export const SET_SELLER = "SET_SELLER";
export const SET_FILTERED_PRODUCTS = "SET_FILTERED_PRODUCTS";
export const SET_SELECTED_AMOUNTS = "SET_SELECTED_AMOUNTS";
export const SET_FACTORY = "SET_FACTORY";
export const SET_TEOLLISUUS_SELLER = "SET_TEOLLISUUS_SELLER";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const SET_FILTER_CATEGORY = "SET_FILTER_CATEGORY";
export const UPDATE_WINTER_FILTER = "TOGGLE_WINTER_FILTER";
export const UPDATE_ECO_FILTER = "TOGGLE_ECO_FILTER";

// Actions
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const UPDATE_DISTANCE = "UPDATE_DISTANCE";
export const FETCH_SWEDISH_SELLER = "FETCH_SWEDISH_SELLER";
export const FETCH_TEOLLISUUS_SELLER = "FETCH_TEOLISUUS_SELLER";
export const UPDATE_FILTER_URL = "UPDATE_FILTER_URL";
export const UPDATE_FILTER_CATEGORY = "UPDATE_FILTER_CATEGORY";
